import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import config from "../../config";
import Loader from "../../Component/Loader";
import useLogout from "../Auth/useLogout";

export default function Enquiry() {
  const logout = useLogout();
  const user = config.user;
  const userType = user ? user.type : "";
  const [brand, setBrand] = useState([]);
  const [product, setProduct] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    company_name: "",
    phone: "",
    email: "",
    gst_number: "",
    delivery_location: "",
    brand: "",
    product: "",
    requirement: "",
    message: "",
  });
  const [error, setError] = useState({
    name: "",
    phone: "",
    delivery_location: "",
    brand: "",
    product: "",
    requirement: "",
  });
  const fetchUserProfile = useCallback(async () => {
    try {
      let apiUrl = "";
      if (userType === "seller") {
        apiUrl = `${config.apiUrl}/seller/profile`;
      } else if (userType === "transporter") {
        apiUrl = `${config.apiUrl}/transporter/profile`;
      } else {
        apiUrl = `${config.apiUrl}/customer/profile`;
      }
      const response = await axios.get(apiUrl, {
        headers: {
          "Content-Type": "application/json",
          Authorization: config.token,
          Accept: "application/json",
        },
      });
      setFormData((prevData) => ({
        ...prevData,
        name: response.data.data.name ?? "",
        phone: response.data.data.phone ?? "",
        email: response.data.data.email ?? "",
        company_name:
          userType === "seller"
            ? response.data.data.business_details?.name
            : userType === "transporter"
            ? response.data.data.transporter_detail?.company_name
            : response.data.data.user_detail?.company_name,
        gst_number:
          userType === "seller"
            ? response.data.data.kyc_details?.gst_number
            : userType === "transporter"
            ? response.data.data.transporter_detail?.gst_number
            : response.data.data.user_detail?.gst_number,
      }));
    } catch (error) {
      if (error.response && error.response.status === 401) {
        logout();
      }
    }
  }, [logout, userType]);

  useEffect(() => {
    fetchUserProfile();
  }, [fetchUserProfile]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const validate = () => {
    const newError = {};
    if (!formData.name) {
      newError.name = "Please enter your name";
    }
    if (
      !formData.phone ||
      formData.phone.length !== 10 ||
      isNaN(formData.phone)
    ) {
      newError.phone = "Please enter valid phone number";
    }
    if (!formData.delivery_location) {
      newError.delivery_location = "Please enter delivery location";
    }
    if (!formData.brand) {
      newError.brand = "Please select brand";
    }
    if (!formData.product) {
      newError.product = "Please select product";
    }
    if (!formData.requirement) {
      newError.requirement = "Please enter requirement";
    }
    setError(newError);
    return Object.keys(newError).length === 0;
  };
  const fetchBrand = useCallback(async () => {
    try {
      const response = await axios.get(`${config.apiUrl}/brand-list`);
      setBrand(response.data.brand_list);
    } catch (error) {}
  }, []);
  useEffect(() => {
    fetchBrand();
  }, [fetchBrand]);
  const fetchProduct = useCallback(async (e) => {
    const brand_id = e.target.value;
    if (brand_id) {
      try {
        const response = await axios.get(
          `${config.apiUrl}/seller-commodity-product-list/${brand_id}`
        );
        setProduct(response.data.product_list);
      } catch (error) {}
    }

    setFormData((prev) => ({
      ...prev,
      brand: brand_id,
    }));
  }, []);
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setLoading(true);
      try {
        const response = await axios.post(`${config.apiUrl}/general-enquiry`, {
          name: formData.name,
          company_name: formData.company_name,
          contact_number: formData.phone,
          email: formData.email,
          gst_number: formData.gst_number,
          delivery_location: formData.delivery_location,
          brand_id: formData.brand,
          seller_commodity_product_id: formData.product,
          requirement: formData.requirement,
          message: formData.message,
        });
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        resetData();
      } catch (error) {
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, 2000);
      }
    }
  };
  const resetData = () => {
    setFormData({
      name: "",
      company_name: "",
      phone: "",
      email: "",
      gst_number: "",
      delivery_location: "",
      brand: "",
      product: "",
      requirement: "",
      message: "",
    });
  };

  return (
    <>
      <div className="enquiry-top">
        <div className="container-fluid">
          <div className="row gap-row">
            <div className="col-lg-5 mt-4">
              <div className="enquiry-intro">
                <h4>
                  Tell us your{" "}
                  <span className="text-secondary">requirements</span>
                </h4>
                <h1> We would love to hear from you!!</h1>
                <p>
                  Please provide detailed information and our team will get back
                  to you as soon as possible.
                </p>
              </div>
            </div>
            <div className="col-lg-7 my-auto p-lg-5 p-4 bg-white rounded">
              <h6 className="text-secondary">
                Unlock the best rates by filling out the form below
              </h6>

              <form onSubmit={handleSubmit} className="enqry-frm">
                <div className="row g-3">
                  <div className="col-lg-4 px-2">
                    <label className="form-label" htmlFor="name">
                      Name*
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Name of person"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                    />
                    {error.name && (
                      <span className="input-error">{error.name}</span>
                    )}
                  </div>
                  <div className="col-lg-4 px-2">
                    <label className="form-label" htmlFor="company_name">
                      Company Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Company name"
                      id="company_name"
                      name="company_name"
                      value={formData.company_name}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-lg-4 px-2">
                    <label className="form-label" htmlFor="phone">
                      Phone Number*
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Phone number"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      onWheel={(e) => e.target.blur()}
                    />
                    {error.phone && (
                      <span className="input-error">{error.phone}</span>
                    )}
                  </div>
                  <div className="col-lg-4 px-2">
                    <label className="form-label" htmlFor="email">
                      Email
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email address"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-lg-4 px-2">
                    <label className="form-label" htmlFor="gst_number">
                      GST Number
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="GST number"
                      id="gst_number"
                      name="gst_number"
                      value={formData.gst_number}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-lg-4 px-2">
                    <label className="form-label" htmlFor="delivery_location">
                      Delivery Location*
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Delivery city name"
                      id="delivery_location"
                      name="delivery_location"
                      value={formData.delivery_location}
                      onChange={handleChange}
                    />
                    {error.delivery_location && (
                      <span className="input-error">
                        {error.delivery_location}
                      </span>
                    )}
                  </div>
                  <div className="col-lg-4 px-2">
                    <label className="form-label">Brand*</label>
                    <select
                      className="form-control"
                      onChange={fetchProduct}
                      value={formData.brand}
                    >
                      <option value="">Select Brand</option>
                      {brand.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                    {error.brand && (
                      <span className="input-error">{error.brand}</span>
                    )}
                  </div>
                  <div className="col-lg-4 px-2">
                    <label className="form-label">Product*</label>
                    <select
                      className="form-control"
                      name="product"
                      onChange={handleChange}
                      value={formData.product}
                    >
                      <option value="">Select Product</option>
                      {product.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                    {error.product && (
                      <span className="input-error">{error.product}</span>
                    )}
                  </div>
                  <div className="col-lg-4 px-2">
                    <label className="form-label" htmlFor="requirement">
                      Requirement In MT*
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Minimum order 30mt"
                      id="requirement"
                      name="requirement"
                      value={formData.requirement}
                      onChange={handleChange}
                      onWheel={(e) => e.target.blur()}
                    />
                    {error.requirement && (
                      <span className="input-error">{error.requirement}</span>
                    )}
                  </div>
                  <div className="col-lg-12 px-2">
                    <label className="form-label" htmlFor="message">
                      Your Message
                    </label>
                    <textarea
                      className="form-control"
                      rows="2"
                      placeholder="Your message"
                      id="message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                    ></textarea>
                  </div>
                  <div className="col-lg-12 px-2">
                    <button
                      type="submit"
                      className="btn btn-success w-100 rounded"
                      disabled={loading}
                    >
                      {loading ? <Loader /> : "Submit"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
